import { Cell, Column, Heading, TimePeriodValue } from "@edgetier/client-components";
import { differenceInSeconds } from "date-fns";
import { FunctionComponent, memo } from "react";
import { IAgent } from "@edgetier/watchtower-types";
import { IProps } from "./live-agents-table-signed-duration-column.types";
import "./live-agents-table-signed-duration-column.scss";

/**
 * Display for how long an agent has been in the current state.
 * @returns Sortable agent state duration column.
 */
const LiveAgentsTableSignedDurationColumn: FunctionComponent<IProps> = () => {
    return (
        <Column>
            <Heading sortProperty="lastLoginDateTime" reverseSortDirection>
                Time Signed In
            </Heading>
            <Cell<Pick<IAgent, "lastLoginDateTime">>>
                {({ lastLoginDateTime }) => (
                    <TimePeriodValue
                        seconds={
                            lastLoginDateTime instanceof Date
                                ? differenceInSeconds(new Date(), lastLoginDateTime)
                                : null
                        }
                    />
                )}
            </Cell>
        </Column>
    );
};

export default memo(LiveAgentsTableSignedDurationColumn);
